// TODO: implement seed types instead of any (e.g.: string, number, number[], string[], etc.)
import { RandomEngine } from '@grandom/core';
import MT19937 from '@grandom/mt19937';
import fnv1a from '@grandom/fnv1a';
export default class MT19937Engine extends RandomEngine {
    constructor() {
        super('mt19937');
        this._engine = new MT19937();
        this.seed = Math.floor(Math.random() * new Date().getTime());
    }
    get seed() {
        return this._seed;
    }
    set seed(seed) {
        if (typeof seed === 'number') {
            this._engine.seed = seed;
            this._seed = seed;
        }
        else if (typeof seed === 'string') {
            this._engine.seed = fnv1a(seed);
            this._seed = seed;
        }
        else {
            throw new TypeError(
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `Seed must be a number, or a string, got: ${seed} (typeof === '${typeof seed}').`);
        }
    }
    _next() {
        return this._engine.randomFloat2();
    }
}
//# sourceMappingURL=index.js.map